/**
 * Hook for creating color scale functions
 * Wraps colorAlgorithms utility with React memoization
 */

import { useMemo } from 'react'

import { createColorFunction } from '@aytm/app/stats/page/question-views/components/word-cloud/utils/colorAlgorithms'

/**
 * Hook to create color function based on style and config
 *
 * @param {string} colorStyle - Color style: 'adj_levels', 'levels', 'gradient', 'circle'
 * @param {string[]} colors - Color palette
 * @param {number} rangeFrom - Min font size
 * @param {number} rangeTo - Max font size
 * @param {Object} [sizes] - Size distribution map (for adj_levels)
 * @returns {Function} Color function (size, index?) => color
 */
export function useColorScale(colorStyle, colors, rangeFrom, rangeTo, sizes = null) {
  return useMemo(
    () =>
      createColorFunction(colorStyle, {
        colors,
        from: rangeFrom,
        to: rangeTo,
        sizes
      }),
    [colorStyle, colors, rangeFrom, rangeTo, sizes]
  )
}

export default useColorScale
